import React, { useState, useMemo, useEffect, useRef, ReactNode } from 'react';
import { useSetRecoilState, useRecoilValue, useRecoilState } from 'recoil';
import styled from 'styled-components';
import LS from '@/styles/layoutStyled';
import CS from '@/styles/componentStyled';
import BS from '@/styles/btnStyled';
import IS from '@/styles/inputStyled';

interface TitleTextBoxProps {
  text: string;
}

const TitleTextBox = ({ text }: TitleTextBoxProps) => {
  return (
    <>
      <Box className="flex aic">
        <span className="img-box">
          <img src="/img/ico_title_dot.svg" alt="" />
        </span>
        <h1 className="tm">{text}</h1>
      </Box>
    </>
  );
};

export default TitleTextBox;

const Box = styled.div`
  gap: 6px;
  .img-box {
    width: 20px;
  }
  > h1 {
    font-size: 18px;
    color: #222;
  }
  @media (max-width: 1420px) {
    gap: 3px;
    .img-box {
      width: 16px;
    }
    > h1 {
      font-size: 16px;
    }
  }
`;
